// Thin fetch wrapper for /api/admin/permissions.

import { adminGet } from "@/data/httpClient";
import { unwrapEnvelope } from "@/data/unwrapEnvelope";
import type { PermissionCatalog } from "@/types/role";

export interface PermissionClient {
  getCatalog(): Promise<PermissionCatalog>;
}

function createPermissionClient(): PermissionClient {
  return {
    getCatalog() {
      // Enveloped as {"catalog": {catalog_version, groups[]}}; unwrap so
      // callers read catalog.groups (returning the raw envelope left groups
      // undefined and crashed RoleDetailPage on `catalog.groups.reduce`).
      return adminGet<PermissionCatalog>("/api/admin/permissions").then(
        (resp) => unwrapEnvelope(resp, "catalog"),
      );
    },
  };
}

/** Singleton permission client instance. */
export const permissionClient: PermissionClient = createPermissionClient();
